class APIS {
	apis() {
		return {
			callChatbotCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call-chatbot/create'
			},
			callChatbotUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call-chatbot/update'
			},
			callChatbotGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call-chatbot/get-all'
			},
			callChatbotDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call-chatbot/delete'
			}
		};
	}
}

export default new APIS();
